import { render, staticRenderFns } from "./Cirujias.vue?vue&type=template&id=382bb8e0&scoped=true"
import script from "./Cirujias.vue?vue&type=script&lang=js"
export * from "./Cirujias.vue?vue&type=script&lang=js"
import style0 from "./Cirujias.vue?vue&type=style&index=0&id=382bb8e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bb8e0",
  null
  
)

export default component.exports